import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { User } from '@linktivity/link-icons';
import { Dropdown, message } from '@linktivity/link-ui';
import type { IUserProps } from './User.types';
import styles from './user.module.css';
const UserView: React.FC<IUserProps> = ({ email = '', logout }: IUserProps) => {
  const { t } = useTranslation();
  const [openMenu, setOpenMenu] = useState(false);

  const userButton = useMemo(
    () => (
      <button
        className={styles.button}
        type="button"
        onClick={() => setOpenMenu(visible => !visible)}
      >
        <User className={styles.icon} />
        <span className={styles.text}>{t('share.common.account')}</span>
      </button>
    ),
    [t]
  );

  return (
    <Dropdown
      target={userButton}
      visible={openMenu}
      sameWidth={false}
      placement="bottom-end"
      onClose={() => setOpenMenu(false)}
    >
      <Dropdown.Menu className={styles.dropdownMenu}>
        <Dropdown.Item>
          <button
            className={styles.dropdownButton}
            onClick={() => message.info(email || '', 10)}
          >
            <span className={styles.dropdownText}>{email || ''}</span>
          </button>
        </Dropdown.Item>
        <Dropdown.Item>
          <button className={styles.dropdownButton} onClick={logout}>
            {t('share.common.signOut')}
          </button>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
export default UserView;
